import { z } from 'zod';

export const UpdateCurationInfoServiceRequestSchema = z
  .object({
    description: z.string().max(60),
  })
  .describe('UpdateCurationInfoServiceRequestSchema');

export type UpdateCurationInfoServiceRequest = z.infer<
  typeof UpdateCurationInfoServiceRequestSchema
>;

export const UpdateCurationInfoServiceResponseSchema = z
  .object({
    description: z.string(),
    curatorId: z.string(),
  })
  .describe('UpdateCurationInfoServiceResponseSchema');

export type UpdateCurationInfoServiceResponse = z.infer<
  typeof UpdateCurationInfoServiceResponseSchema
>;
